import { render } from "./DocumentTypeList.vue?vue&type=template&id=7679fc7e&scoped=true"
import script from "./DocumentTypeList.vue?vue&type=script&lang=js"
export * from "./DocumentTypeList.vue?vue&type=script&lang=js"

import "./DocumentTypeList.vue?vue&type=style&index=0&id=7679fc7e&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7679fc7e"]])

export default __exports__